import { PUBLIC_PREFIX, REWARDS_PATH_S3 } from 'constants/images'
import { RewardTypeEnum } from '__generatedTypes__/globalTypes'
import { ImageField } from 'components/DropzoneField'
import { uploadImage } from 'utils/saveImageS3'
import { validateRequiredNumber } from 'utils/validation'

import { MEMBERSHIP_EXTENSION_AWARD_TYPE } from '../consts'
import { FormValues } from './Form'

export const validateMysteryBoxPercentage = (value: string) => {
  const required = validateRequiredNumber(value)

  if (required) {
    return required
  }

  const percentage = Number(value)

  if (percentage < 0 || percentage > 100) {
    return 'Percentage must be between 0 and 100'
  }

  return undefined
}

const getFullImagePath = (path?: string) => {
  if (!path) {
    return undefined
  }

  return `${process.env.REACT_APP_IMAGEKIT_URL}/tr:h-default,w-default/${PUBLIC_PREFIX}/${path}`
}

export const uploadFiles = async (imageLight: ImageField | undefined, imageDark: ImageField | undefined) => {
  const imageLightFile = imageLight?.isUploaded ? null : imageLight?.file
  const imageDarkFile = imageDark?.isUploaded ? null : imageDark?.file

  const [imageLightPath, imageDarkPath] = await Promise.all([
    imageLightFile
      ? uploadImage(imageLightFile, REWARDS_PATH_S3).then(getFullImagePath)
      : Promise.resolve(imageLight?.initialValue),
    imageDarkFile
      ? uploadImage(imageDarkFile, REWARDS_PATH_S3).then(getFullImagePath)
      : Promise.resolve(imageDark?.initialValue),
  ])

  return [imageLightPath, imageDarkPath]
}

// pass 1 as a value for other rewards
const DEFAULT_REWARD_VALUE = 1

export const getValue = (values: FormValues) => {
  if (values.type.id === RewardTypeEnum.Extension && values.extension) {
    return MEMBERSHIP_EXTENSION_AWARD_TYPE[values.extension.id].awardTypeValue
  }

  return DEFAULT_REWARD_VALUE
}
